import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Space, Spin } from 'antd';
import { UserOutlined, LockOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { getString } from '../utils/translations';

const { Title, Text } = Typography;

const AuthLogin = () => {
  const [form] = Form.useForm();
  const { signIn, loading } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      const success = await signIn(values.email, values.password);
      if (!success) {
        // Error notification handled by signIn function
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Card 
        style={{ 
          width: 400, 
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          borderRadius: 12
        }}
        bordered={false}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <VideoCameraOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
          <Title level={2} style={{ margin: 0, color: '#262626' }}>
            {getString('pipeline.auth.platform_title', 'Video Dashboard Pro')}
          </Title>
          <Text type="secondary">
            {getString('pipeline.auth.sign_in_prompt', 'Sign in with your SDK account to access video processing')}
          </Text>
        </div>

        <Spin spinning={loading || isSubmitting}>
          <Form
            form={form}
            name="login"
            onFinish={handleSubmit}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: getString('pipeline.auth.please_enter_email', 'Please enter your email') },
                { type: 'email', message: getString('pipeline.auth.please_enter_valid_email', 'Please enter a valid email address') }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder={getString('pipeline.auth.email', 'Email address')}
                disabled={isSubmitting}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: getString('pipeline.auth.please_enter_password', 'Please enter your password') },
                { min: 6, message: getString('pipeline.auth.password_min_length', 'Password must be at least 6 characters') }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder={getString('pipeline.auth.password', 'Password')}
                disabled={isSubmitting}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={isSubmitting}
                disabled={loading}
              >
                {getString('pipeline.auth.sign_in', 'Sign In to Video Dashboard Pro')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>

        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Space direction="vertical" size="small">
            <Text type="secondary" style={{ fontSize: 12 }}>
              🔒 {getString('pipeline.auth.secured_by', 'Secured by Firebase Authentication')}
            </Text>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default AuthLogin;
